import { Box } from '@factorialco/deprecated-design-system'

interface Props {
  dashed?: boolean
  overlayKey?: string
}

const SelectionOverlay = ({ dashed = false, overlayKey }: Props) => (
  <Box
    aria-hidden="true"
    extra={
      overlayKey
        ? {
            'data-time-grid-selection-overlay-key': overlayKey,
          }
        : undefined
    }
    className={
      dashed ? 'border border-dashed border-f1-border-selected-bold' : 'bg-f1-background-selected'
    }
    style={{
      position: 'absolute',
      inset: '0',
      pointerEvents: 'none',
      zIndex: '2',
      boxSizing: 'border-box',
    }}
  />
)

export { SelectionOverlay }
